import React, { useState } from 'react';
import { Fragment } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { Form, Row, message } from 'antd';
import { Text } from 'react-konva';
import { sbaas } from '@/config';

const SppResultVoucher = ({  }: RouteComponentProps) => {
  const state = useHistory().location.state as { data: JSON };
  type LayoutType = Parameters<typeof Form>[0]['layout'];

  const [formLayout, setFormLayout] = useState<LayoutType>('vertical');
  const [form] = Form.useForm();

  const onFormLayoutChange = ({ layout }: { layout: LayoutType }) => {
    setFormLayout(layout);
  };

  var name = state.data['name'];
  var phone = state.data['phone_number'];
  var dob = state.data['dob'];
  var idNumber = state.data['id_number'];
  var schoolName = state.data['school_name'];
  var email = state.data['email'];
  var vcode = state.data['voucher_code'];
  var expiredDate = state.data['expired_date'];
  var storeName = state.data['store_name'];
  var selectedDevice = state.data['selected_device'];

  const sendToEmail = async () => {
    try {
      await sbaas
        .script('spp-push-email-voucher-code')
        .post({
          body: {
            name: name,
            phone: phone,
            dob: dob,
            idNumber: idNumber,
            schoolName: schoolName,
            email: email,
            vcode: vcode,
            expiredDate: expiredDate,
            storeName: storeName,
            selectedDevice: selectedDevice,
          },
        })
        .then(res => {
          console.log('[spp-push-email-voucher-code] res : ', res);
          message.info(
            'Kode voucher telah dikirim ke ' +
              email +
              ', cek inbox/ spam di email',
          );
        });
    } catch (error) {}
  };

  return (
    <div>
      <Fragment>
        <Row
          style={{
            maxWidth: '850px',
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center',
            margin: 'auto',
          }}
        >
          <img
            src={require('./StudentOfferBanner.jpg')}
            className="spp-header-banner"
          />
          <div className="result-form-content">
            <div
              style={{
                color: '#000000',
                margin: '15px 0 25px 0',
                fontSize: '14px',
                fontWeight: 'normal',
                display: 'inline',
                textAlign: 'center',
              }}
            >
              <Text>Terima kasih telah mengikuti</Text>
              <Text
                style={{
                  fontFamily: 'Samsung Sharp Sans Bold',
                  fontWeight: 'bold',
                }}
              >
                {' '}
                Student Purchase Program{' '}
              </Text>
              <Text> dari Samsung </Text>
            </div>
            <Form
              layout={formLayout}
              form={form}
              initialValues={{ layout: formLayout }}
              onValuesChange={onFormLayoutChange}
            >
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>Nama Lengkap:</span>
                }
              >
                <Text style={{ fontWeight: 'bold', color: '#33d6cb' }}>
                  {' '}
                  {name}{' '}
                </Text>
              </Form.Item>
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>Nomor Telepon:</span>
                }
              >
                <Text style={{ fontWeight: 'bold', color: '#33d6cb' }}>
                  {' '}
                  {phone}{' '}
                </Text>
              </Form.Item>
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>Tanggal Lahir:</span>
                }
              >
                <Text style={{ fontWeight: 'bold', color: '#33d6cb' }}>
                  {' '}
                  {dob}
                </Text>
              </Form.Item>
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    No Identitas Pelajar:
                  </span>
                }
              >
                <Text style={{ fontWeight: 'bold', color: '#33d6cb' }}>
                  {' '}
                  {idNumber}{' '}
                </Text>
              </Form.Item>
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Sekolah/ Universitas:
                  </span>
                }
              >
                <Text style={{ fontWeight: 'bold', color: '#33d6cb' }}>
                  {' '}
                  {schoolName}{' '}
                </Text>
              </Form.Item>
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Unit yang tertarik untuk dibeli:
                  </span>
                }
              >
                <Text style={{ fontWeight: 'bold', color: '#33d6cb' }}>
                  {' '}
                  {selectedDevice}{' '}
                </Text>
              </Form.Item>
              <Form.Item
                label={<span style={{ fontWeight: 'bold' }}>Email:</span>}
              >
                <Text style={{ fontWeight: 'bold', color: '#33d6cb' }}>
                  {' '}
                  {email}{' '}
                </Text>
              </Form.Item>
              <body
                style={{
                  textAlign: 'center',
                  fontSize: '11px',
                  fontWeight: 'bold',
                  margin: '20px 0 20px 0',
                }}
              >
                <p>Berikut adalah kode voucher kamu:</p>
                <h2 style={{ fontSize: '23px', fontWeight: 'bold' }}>
                  {vcode}
                </h2>
                <p>Kode voucher di atas berlaku sampai {expiredDate}</p>
                <p>
                  Gunakan kode voucher di atas untuk pembelian produk impian
                  kamu hanya di{' '}
                  <b>
                    <a
                      style={{ color: '#1890FF', textDecoration: 'underline' }}
                      href="https://www.samsung.com/id/samsung-experience-store/locations/"
                    >
                      Samsung Experience Store
                    </a>
                  </b>{' '}
                  terdekat.
                </p>
                <p />
                <p>
                  Untuk Informasi lebih lanjut silakan kunjungi toko yang kamu
                  pilih {storeName}
                </p>
                <br />
                <br />
                <p style={{ margin: '0px' }}>
                  Kode voucher telah dikirim ke {email}, silakan cek inbox/
                  spam.
                </p>
                <p style={{ margin: '6px' }}>Tidak mendapatkan kode voucher?</p>
                <a
                  onClick={sendToEmail}
                  style={{ fontSize: '13px', fontWeight: 'normal' }}
                >
                  <u>Kirim ulang KODE VOUCHER ke EMAIL</u>
                </a>
              </body>
            </Form>
          </div>
        </Row>
      </Fragment>
    </div>
  );
};

export default SppResultVoucher;
